import React, { Children, FC } from 'react';

import { Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { ISettingsFrameProps } from './interfaces';
import s from './SettingsFrame.module.scss';

export const SettingsFrame: FC<ISettingsFrameProps> = ({
  children,
  separator,
}) => {
  const childrenArray = Children.toArray(children).filter(Boolean);

  return (
    <div className={cn(s.container)}>
      {childrenArray.map((child, index) => (
        <>
          <div key={index}>{child}</div>
          {index === 0 && separator && <Separator />}
        </>
      ))}
    </div>
  );
};
